import { Route, Routes } from 'react-router-dom';

import { PgmMainMenu, NavigationMenu } from '../side-nav';
import RoutePerformanceLog from '../performance-log/RoutePerformanceLog';
import { SitesOverviewPage, SitesPage, BusinessServicesPage, ReportsPage } from '../pages';
import '../panels';
import '../filters';
import { LastLocation } from '../side-nav/SidebarLocationHistory';
import PgmAdminPages from '../pages-admin/PgmAdminPages';
import PlmPages from './PlmPages';
import LastPageRedirector from './LagePageRedirector';
import { UserPages } from './UserPages';

export default function PgmPages() {
    return (
        <LastLocation stateId="pgm-main-menu-state">
            {(lastLocationUrl) => {
                return (
                    <NavigationMenu
                        title="Global"
                        id="pgm-main"
                        lastUrl={lastLocationUrl}
                        showTitle={false}
                        render={() => <PgmMainMenu />}
                    >
                        <Routes className="flex-container">
                            <Route path="/admin/*" element={<PgmAdminPages />} />
                            <Route path="/users/*" element={<UserPages />} />
                            <Route path="/plm/:plmId/*" element={<PlmPages />} />

                            <Route path="/" element={<LastPageRedirector />} />

                            <Route path="/*">
                                <RoutePerformanceLog path="sites-overview" element={SitesOverviewPage} />
                                <RoutePerformanceLog path="sites" element={SitesPage} />
                                <RoutePerformanceLog path="business-services" element={BusinessServicesPage} />
                                <RoutePerformanceLog path="reports" element={ReportsPage} />
                            </Route>
                        </Routes>
                    </NavigationMenu>
                );
            }}
        </LastLocation>
    );
}
